/* Esternal */
import cloneDeepL from "lodash/cloneDeep";
import { call, all, select, race, take } from "redux-saga/effects";

/* Actions */
import { baseActionName } from "./actions";
import { actionTypes as heartbeatActionTypes } from "../player/heartbeat/actions";

/* Services */
import backendService from "../../services/backend";

/* Utils */
import { makeFetchSaga, LANDERS_URIS, HOME_BATCH_SIZE, SECTIONS_URIS, STATUS_TYPES } from "../../utils";

function* fetchHomeTab() {
  const { homeCarousels: batchSize = HOME_BATCH_SIZE } = yield select((state) => state.global.configurationAEM.data);
  const stateCarousels = yield select((state) => state.homeTab.data);
  let carousels;

  if (stateCarousels.length > 0) {
    carousels = cloneDeepL(stateCarousels);
  } else {
    const response = yield call(backendService.content.getPage, LANDERS_URIS.HOME);
    const sections = response.data?.page?.sections || [];

    carousels = sections.reduce((carousels, { sectionID: id }) => {
      if (
        id.toLowerCase() !== "featured" &&
        id !== SECTIONS_URIS.MY_LIST &&
        id !== SECTIONS_URIS.CONTINUE_WATCHING_LIVE
      )
        carousels.push({ id, label: null, items: null });
      return carousels;
    }, []);
  }

  let nextBatchSize = batchSize;
  const isContinueWatching = (carouselId) =>
    [SECTIONS_URIS.CONTINUE_WATCHING, SECTIONS_URIS.CONTINUE_WATCHING_TA].includes(carouselId);

  do {
    let carouselsToFetch = carousels.filter(({ id, items }) => items === null || isContinueWatching(id));

    if (carouselsToFetch.length === 0) break;

    let fetchedCarouselsCount = 0,
      carouselItems = [],
      carouselLabel = "";
    const carouselsBatch = carouselsToFetch.slice(0, nextBatchSize);

    yield all(
      carouselsBatch.map(function* ({ id: carouselToFetchId }) {
        try {
          if (isContinueWatching(carouselToFetchId)) {
            const heartbeatStatus = yield select((state) => state.player.heartbeat.status);

            if (heartbeatStatus === STATUS_TYPES.INIT_STATE) {
              yield race({
                heartbeatSuccess: take(heartbeatActionTypes.SUCCESS),
                heartbeatFailure: take(heartbeatActionTypes.FAILURE)
              });
            }
          }

          const response = yield call(backendService.content.getPageSection, LANDERS_URIS.HOME, carouselToFetchId);
          const { contents, label } = response?.data || {};

          carouselItems = contents;
          carouselLabel = label;

          if (!carouselItems?.length) throw new Error("Empty carousel");

          const carousel = carousels.find(({ id }) => id === carouselToFetchId);

          carousel.items = carouselItems;
          carousel.label = carouselLabel;

          fetchedCarouselsCount += 1;
        } catch (error) {
          const carouselIndex = carousels.findIndex(({ id }) => id === carouselToFetchId);

          carousels.splice(carouselIndex, 1);
          console.error("homeTab-fetchHomeTab", error);
        }
      })
    );

    nextBatchSize -= fetchedCarouselsCount;

    // Keep fetching carousels until the batch size is met
  } while (nextBatchSize > 0);

  return { data: carousels };
}

const fetchHomeTabSaga = makeFetchSaga(baseActionName, fetchHomeTab);

export default function* allStations() {
  yield all([fetchHomeTabSaga]);
}
